import CloseIcon from '@material-ui/icons/Close'
import BlockContent from '@sanity/block-content-to-react'
import { graphql } from 'gatsby'
import React from 'react'
import Modal from 'styled-react-modal'

import useSiteSettings from '../../../../hooks/useSiteSettings'
import { serializers } from './serializers'
import * as Styled from './styled'

import modalHeaderImage from '../../../../img/truemed-modal-header.svg'
import step1Image from '../../../../img/truemed-step-1.png'
import step2Image from '../../../../img/truemed-step-2.png'
import step3Image from '../../../../img/truemed-step-3.png'

interface Props {
  onClose: () => void
  isOpen: boolean
}

const DefaultContent = () => {
  return (
    <>
      <Styled.ModalContentTitle>Use your HSA/FSA funds</Styled.ModalContentTitle>
      <Styled.SubTitle>Step 1</Styled.SubTitle>
      <Styled.Text>
        Click Proceed to <strong>Checkout.</strong>
      </Styled.Text>
      <Styled.StepImage src={step1Image} alt="Step 1" />

      <Styled.SubTitle>Step 2</Styled.SubTitle>
      <Styled.Text>
        Enter your Shipping <strong>Address.</strong>
      </Styled.Text>
      <Styled.StepImage src={step2Image} alt="Step 2" />

      <Styled.SubTitle>Step 3</Styled.SubTitle>
      <Styled.Text>
        Select <strong>Pay with Truemed</strong> — you’ll be redirected to Truemed to complete
        verification and payment, then return to finish your order.
      </Styled.Text>
      <Styled.StepImage src={step3Image} alt="Step 3" />
    </>
  )
}

export const TruemedModal: React.FC<Props> = ({ onClose, isOpen }) => {
  const settings = useSiteSettings() || {}
  return (
    <Modal onBackgroundClick={onClose} onEscapeKeydown={onClose} isOpen={isOpen}>
      <Styled.ModalContent>
        <Styled.HeaderContainer>
          <Styled.TruemedModalHeader src={modalHeaderImage} alt="Truemed" />
          <Styled.CloseButton onClick={onClose}>
            <CloseIcon />
          </Styled.CloseButton>
        </Styled.HeaderContainer>
        <Styled.ContentContainer tabIndex={-1}>
          {settings._rawPdpTruemedModalContent ? (
            <BlockContent blocks={settings._rawPdpTruemedModalContent} serializers={serializers} />
          ) : (
            <DefaultContent />
          )}
        </Styled.ContentContainer>
      </Styled.ModalContent>
    </Modal>
  )
}

export const truemedModalContent = graphql`
  fragment pdpTruemedModalContentFragment on SanitySiteSettings {
    _rawPdpTruemedModalContent(resolveReferences: { maxDepth: 10 })
  }
`
